export const ACCREDITATION_ATTEMPT = 'ACCREDITATION_ATTEMPT';
export const ACCREDITATION_SUCCESS = 'ACCREDITATION_SUCCESS';
export const ACCREDITATION_FAILURE = 'ACCREDITATION_FAILURE';

export const CLEAR_ACCREDITATION_STATE = 'CLEAR_ACCREDITATION_STATE';
export const CLEAR_STATE = 'CLEAR_STATE';
